export function stripRTFTags(text: string): string {
  // strip HTML-like tags from text
  return text.replace(/<[^>]*>?/gm, "");
}
